/**
 * Converts a standard date string (YYYYMMDD or YYYYMMDDHHMM) and optional time string (HHMM)
 * to a Date object.
 * If time is provided, it will set the date to that time in UTC.
 * Otherwise this will use the current local time
 *
 * @param {string} refreshString
 * @param {string=} refreshTime
 * @returns {Date}
 */
export function convertStdDateString(refreshString, refreshTime) {
  var fmtedDateString = refreshString;
  var y = fmtedDateString.slice(0, 4),
    m = fmtedDateString.slice(4, 6) - 1,
    d = fmtedDateString.slice(6, 8);
  var hour = 0;
  var min = 0;

  if (!refreshTime && refreshString.length === 12)
    refreshTime = fmtedDateString.slice(fmtedDateString.length - 4);

  if (refreshTime) {
    hour = parseInt(refreshTime.slice(0, 2));
    min = parseInt(refreshTime.slice(2, 6));
    return new Date(Date.UTC(y, m, d, hour, min));
  } else {
    return new Date(y, m, d);
  }
}
